import actions from "@/store/actions/ins_media_action";
import mutations from "@/store/mutations/ins_media_mutation";
import getters from "@/store/getters/ins_media_getter";

export interface OneMediaInfo {
  comment_count: number;
  comments_disabled: boolean;
  display_url: string;
  id: string;
  is_video: boolean;
  like_count: number;
  shortcode: string;
  video_icon: string;
  media_type: number;
  video_view_count: number;
}
export interface OneUserMediaInfoList {
  user_id: string;
  user_type: "login" | "search";
  fetch_status: "fetching" | "failed" | "idle";
  fetched: boolean;
  more_available: boolean;
  next_max_id: string | undefined | null;
  // user_name: string;
  ins_media_list: OneMediaInfo[];
}
export interface UpdateInsMediaInfo {
  insMediaInfoList: OneUserMediaInfoList;
  upsateStatus: "new" | "delete" | "more"; // 刷新与新增都是new,delete 删除， more 加载更多
}

export interface InsUserMediaList {
  ins_user_media_list: OneUserMediaInfoList[];
  current_post_id: string | null;
}
type stateType = () => InsUserMediaList;

export const state: stateType = () => ({
  ins_user_media_list: [],
  current_post_id: null
});
export default {
  state,
  actions,
  getters,
  mutations
};
